import React, {useRef, useEffect, useState, useLayoutEffect} from "react";
import { AnimatePresence, motion, usePresence } from "framer-motion";
import { projData } from "../../globals/data";
import ProjectVideo from "../../components/ProjectVideo/ProjectVideo";
import { charUpWrapperVariants, customTextVariants, fullscreenOptionVariants, lowerGLVariants, nextPrevVariants, textVariants, timerWrapperVariants, tsPlayModeVariants, upperGLVariants } from "./variants";
import ProjectGallery from "../../components/ProjectGallery/ProjectGallery";
import LocomotiveScroll from 'locomotive-scroll';
import MetaCreditComponent from "../../components/MetaCreditComponent/MetaCreditComponent";
import NextPrevComponent from "../../components/NextPrevComponent/NextPrevComponent";
import CornerComponent from "../../components/CornerComponent/CornerComponent";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import MobileControls from "../../components/MobileControls/MobileControls";
import { getGutterWidth, smoothScrollTo } from "../../globals/helpers";
import ProgressiveGalleryImage from "../../components/ProgressiveGalleryImage/ProgressiveGalleryImage";
import {primaryInput} from "detect-it";
import MobBoldQuote from "../../components/mobBoldQuote/MobBoldQuote";
import MobSplitQuote from "../../components/MobSplitQuote/MobSplitQuote";
import MobOverlapQuote from "../../components/MobOverlapQuote/MobOverlapQuote";
import { imageSizingMapping } from "../../globals/variables";
import './project.css';

const Project = ({setCursorText}) => {
    const { projectID } = useParams();
    const location = useLocation();
    const scrollRef = useRef();
    const mainContentref = useRef();
    const appliedScrollRef = useRef();

    const [isPresent, safeToRemove] = usePresence();
    const [gutter,setGutter] = useState(null);
    const [isFromProject, setIsFromProject] = useState(false);
    const [performInitialCorners, setPerformInitialCorners] = useState(false);
    const [performInitialGrid, setPerformInitialGrid] = useState(false);
    const [scroller, setScroller] = useState(null);
    const [nextProject, setNextProject] = useState(null);
    const [prevProject, setPrevProject] = useState(null);
    const [isProjectExit, setIsProjectExit] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth<600);
    const transitionGLRef = useRef(null);
    const mainBodyRef = useRef(null);
    const extenderRef = useRef(null);
    const [isSecondaryView, setIsSecondaryView] = useState(window.innerWidth <= 750);
    const [isExitingFullscreen, setIsExitingFullscreen] = useState(false);
    const [aspectRatio, setAspectratio] = useState(null);
    const [dynamicSrcType, setDynamicSrcType] = useState(null);
    const touchScrollerRef = useRef(null);
    const navigate = useNavigate();
    const creditSectionRef = useRef(null);
    const [isSafari, setIsSafari] = useState(null);
    const [resetCursor, setResetCursor] = useState(false);
    const [renderGallery, setRenderGallery] = useState(false);

    const [isVideoLoading2, setIsVideoLoading2] = useState(false)



   

    const charUpVariants = {
        initial: {
            transform: "translate3d(0, 175%, 0)",
            opacity: 1
        }, animate: {
            opacity: 1,
            transform: "translate3d(0, 0%, 0)",
            transition: {
                duration: 1.5,
                ease: [0.16, 1, 0.3, 1]
            }
        }, exit: {
            transform: "translate3d(0, 100%, 0)",
            opacity: 1,
            transition: {
                duration: 0.65
            }
        }
    }

    const extraWrapperVariants = {
        initial: {
            opacity: 1,
        }, animate: {
            opacity: 1,
            transition:{
                duration: 0.65,
                delay: isMobile ? 0.5 : 0.35,
                ease: "easeOut"
            }
        }, exit: {
            opacity: 0,
            transition:{
                duration: 0.65,
                ease: "easeOut"
            }
        }
    }

    // video handling
    const [isVideoPlaying2, setIsVideoPlaying2] = useState(false);
    const [seekVideoLocation, setSeekVideoLocation] = useState(0);
    const [isVideoSeeking, setIsVideoSeeking] = useState(false);
    const [videoProgress, setVideoProgress] = useState(0);
    const [timestamp, setTimestamp] = useState(0);
    const [durationTimestamp, setDurationTimestamp] = useState(0);
    const [isMuted, setIsMuted] = useState(false);
    const [muteBlocked, setMuteBlocked] = useState(false);
    const [volume, setVolume] = useState(1);
    const animationRef = useRef(null);
    const startTimeRef = useRef(null);
    const muteDuration = 500;
    const [isFullscreen, setIsFullscreen] = useState(false);

    const [data, setData] = useState(null);
    const [projectNumber, setProjectNumber] = useState(null);
    const [timerLines, setTimerLines] = useState([]);
    const [numberTimerLines, setNumberTimerLines] = useState(null);
    const lineScalers = [0.65, 0.85, 1.05, 0.85, 0.65];
    const windowWidth = ((lineScalers.length - 1)/2)

    const timerRef = useRef(null);
    const timerLineRefs = useRef([]);

    const handleSoundClick = () => {
        if(!muteBlocked){
            setIsMuted(!isMuted);
            setMuteBlocked(true)
        }
    }

    useEffect(() => {
        if(creditSectionRef.current)setRenderGallery(true);
    }, [creditSectionRef.current])

    

    const handleNavigate = (navLoc, isProjectNav) => {
        if(isProjectNav){
            setIsProjectExit(true);
        }
        navigate(navLoc, {state:{isFromProject:true}})
    }

    function responsiveResize(){
        setAspectratio(window.innerWidth/window.innerHeight);
        setGutter(getGutterWidth(window.innerWidth));
        let curWidth = window.innerWidth;
        if (curWidth < 600){
            setIsMobile(true);
        } else if(curWidth <= 775){
            setIsSecondaryView(true);
        } else{
            setIsSecondaryView(false)
        }
    }

    const handleFullscreenClick = () => {
        if(!isFullscreen){
            setIsFullscreen(true);
            if(primaryInput == "mouse"){
                scroller.scrollTo('top', { 
                    'duration': 400,
                    'easing': [0.25, 0.00, 0.35, 1.00],
                
                });
            }else{
                try{
                    smoothScrollTo(
                        touchScrollerRef.current,
                        0,
                        0,
                        500, // 500ms
                        [0.25, 0.0, 0.35, 1.0]
                        );
                }catch{}
            }
        } else{
            setIsFullscreen(false);
        }
    }

    const easeOutQuad = (t) => t * (2 - t);
        // Function to adjust volume
    const adjustVolume = () => {
        // Only start animation if the volume and isMuted state are not in sync
        if (isMuted !== (volume === 0)) {
            const startValue = volume;
            const endValue = isMuted ? 0 : 1; // Transition to 0 if muted, 1 if unmuted

            const startTime = Date.now();
            startTimeRef.current = startTime;

            // Function to run the animation
            const animateVolume = () => {
                const currentTime = Date.now();
                const elapsed = (currentTime - startTime) / muteDuration; 

                if (elapsed < 1) {
                // Easing based on elapsed time
                const easedValue = easeOutQuad(elapsed);
                setVolume(startValue + (endValue - startValue) * easedValue); // Update volume state
                animationRef.current = requestAnimationFrame(animateVolume); // Continue animating
                } else {
                // Ensure the volume is exactly set to the final value
                setVolume(endValue);
                cancelAnimationFrame(animationRef.current); // Stop the animation
                }
            };
            animateVolume();
        }
    };

    const handleSeekEnd = () => {
        setIsVideoSeeking(false);
        setIsVideoPlaying2(true);
        for(let i = 0; i< timerLineRefs.current.length; i++){
            let curRef = timerLineRefs.current[i];
            curRef.style.transform = 'scaleY(0.65)';
            curRef.style.background = 'var(--grid-lines)';
        }
    }

    const handleVideoEnd = () => {
        setIsVideoSeeking(true);
        setIsVideoPlaying2(false);
        setSeekVideoLocation(0.001);
        for(let i = 0; i< timerLineRefs.current.length; i++){
            let curRef = timerLineRefs.current[i];
            curRef.style.transform = 'scaleY(0.65)';
            curRef.style.background = 'var(--grid-lines)';
        }
    }

    const handleTimerLineClick = (e) => {
        let clickX = e.clientX;
        let clickY = e.clientY;
        let timerWidth = timerRef.current.offsetWidth;
        let timerWidthStart = timerRef.current.getBoundingClientRect().x;
        let relativeClickPos = clickX - timerWidthStart;
        let progress = relativeClickPos/timerWidth;
        
        setIsVideoSeeking(true);
        setIsVideoPlaying2(false);
        setSeekVideoLocation(progress);
        for(let i = 0; i< timerLineRefs.current.length; i++){
            let curRef = timerLineRefs.current[i];
            curRef.style.transform = 'scaleY(0.65)';
            curRef.style.background = 'var(--grid-lines)';
        }
    }

    useEffect(() => {
        setTimeout(() => {
            setMuteBlocked(false);
        }, muteDuration)
    }, [muteBlocked])

    useEffect(() => {
        adjustVolume();
    }, [isMuted])

    useEffect(() => {
        if(!isVideoSeeking && videoProgress < 1){
            let targetLineIdx = Math.round(videoProgress * numberTimerLines);
            let lowerBound = Math.max(0, targetLineIdx-windowWidth);
            let upperBound = Math.min(numberTimerLines-1, targetLineIdx+windowWidth+1)
            let effectWindow = timerLineRefs.current.slice(lowerBound, upperBound);

            let startingEffectIdx = 0
            if(effectWindow.length < lineScalers.length){
                if(lowerBound == 0) startingEffectIdx = lineScalers.length - effectWindow.length;
            }
            if(lowerBound > 0){
                timerLineRefs.current[lowerBound-1].style.transform = `scaleY(${0.65})`
                timerLineRefs.current[lowerBound-1].style.background = `var(--grid-lines)`
            }
            for(let i = 0; i< effectWindow.length; i++){
                let scaler = lineScalers[startingEffectIdx];
                let targLine = effectWindow[i];

                targLine.style.transform = `scaleY(${scaler})`;
                targLine.style.background = "var(--light-color)";
                startingEffectIdx++;
            }
        }

    }, [videoProgress])

    useEffect(() => {
        if(!isPresent){
            if(!isMobile && isSafari){
                try{
                    let tmp = document.getElementsByClassName("np_half__wrapper");
                    for(let i = 0; i<tmp.length; i++){
                        tmp.classList.add("no-transition");
                    }
                }catch{}
            }
            safeToRemove()
        }
    }, [isPresent])

    useEffect(() => {
        if(timerRef.current && data){
            let curWidth = timerRef.current.offsetWidth;
            let itemWidth = 5;
            let numberItems = Math.floor(curWidth/itemWidth);
            setNumberTimerLines(numberItems)
            setTimerLines(Array(numberItems).fill(null));
        }
    }, [timerRef, data])

    useLayoutEffect(() => {
        if (scrollRef.current && data && primaryInput !== "touch") {
            const tmpScroll = new LocomotiveScroll({
                el: scrollRef.current,
                smooth: true,
                lerp: 0.05,
                reloadOnContextChange: true,
                multiplier: 1,
                touchMultiplier: 2,
                direction: 'vertical',
                smartphone: {
                    smooth: false,
                    direction: 'vertical'
                },
                tablet: {
                    smooth: true,
                    direction: 'vertical',
        
                },
            });
            setScroller(tmpScroll)
            const handleResize = () => {
            tmpScroll.update();
            };
            const resizeObserver = new ResizeObserver(() => {handleResize();});
            resizeObserver.observe(scrollRef.current);

            let tmpReset = false;
            tmpScroll.on('scroll', (args) => {
                if(args.scroll.y > window.innerHeight){
                    if(!tmpReset){
                            setCursorText("");
                            tmpReset=true;
                    }
                } else{
                    if(tmpReset) tmpReset=false
                }
            })
            return () => {
                resizeObserver.disconnect();
                tmpScroll.destroy();
            };
        }
    }, [data, scrollRef]);


    useEffect(() => {
        for(let i=0; i<projData.length; i++){
            let curTitle = projData[i].title;
            if(curTitle.toUpperCase() == projectID.toUpperCase()){
                setData(projData[i]);
                setProjectNumber(i);
                if(i == projData.length-1) setNextProject(projData[0]); else setNextProject(projData[i+1]);
                if(i == 0) setPrevProject(projData[projData.length - 1]); else setPrevProject(projData[i - 1]);
                break;
            }
        }

        let tmpSafariCheck = window.safari !== undefined;
        if(tmpSafariCheck){setIsSafari(true)}

        responsiveResize();
        window.addEventListener('resize', responsiveResize, false);

        try{
            let tmpRes = location.state.isFromProject;
            if(tmpRes){
                setIsFromProject(true);
                performInitialGrid(false);
            }
        } catch{
        }
        
        try{
            let tmpRes = location.state.isFromArchive;
            if(tmpRes){
                if(window.innerWidth < 600){
                    setPerformInitialGrid(true);
                }else setPerformInitialGrid(false);
            }
        }
        catch{

        }

        try{
            let tmpRes = location.state.isFromHome;
            if(tmpRes){
                if(isMobile)setPerformInitialGrid(true);
                setPerformInitialCorners(true);
            }
        }catch{
            
        }

        try{
            let curWidth = window.innerWidth;
            let replaceSrcWith;
            Object.entries(imageSizingMapping).forEach(([key, value]) => {
                if(curWidth>= value[0] && curWidth <= value[1]){
                    replaceSrcWith = key;
                }
            });
            setDynamicSrcType(replaceSrcWith);
        }catch{

        }

        return() => {
            window.removeEventListener('resize', responsiveResize);
            setCursorText("");
            try{scroller.destroy()}catch{}
        }

       
    }, [])

    const handleMainMouseEnter = () => {
        if(isVideoPlaying2)setCursorText('PAUSE');
        else setCursorText('PLAY');
    }

    const handleMainMouseLeave = () => {
        setCursorText("")
    }

    useEffect(() => {
        if(isVideoPlaying2)setCursorText('PAUSE');
        else setCursorText('PLAY');
    }, [isVideoPlaying2])

    useEffect(() => {
        if(isFullscreen){
            setIsExitingFullscreen(true);
            if(scroller)scroller.stop();

            if(primaryInput == "touch"){
                try{
                    touchScrollerRef.current.style.overflow = "hidden"
                }catch{}
            }
        } else{
            
            setTimeout(() => {
                setIsExitingFullscreen(false);
                if(scroller)scroller.start();
                if(primaryInput == "touch"){
                    try{
                        touchScrollerRef.current.style.overflow = "scroll"
                    }catch{}
                }
            }, 100)
        }
    }, [isFullscreen])

    return(
        <>
            <div
                className="project_page__wrapper"
                style={{
                    overflow: primaryInput !== "mouse" ? "scroll" : null
                }}
                ref={touchScrollerRef}
            >

                <div
                    className="proj-scroll__wrapper"
                    ref={scrollRef}
                    data-scroll-container
                >
                    <div className="project-scroller" data-scroll-section ref={appliedScrollRef}>
                        <div className="main_content_wrapper" ref={mainContentref}>
                            {data &&
                                <React.Fragment>
                                    <div id="main-body-ref" ref={mainBodyRef}>
                                        <div 
                                            className="main_video__wrapper"
                                            style={{
                                                height: isSecondaryView ? `calc((100vw - ${gutter.main*2}px) * ${1/data.aspectRatio}`: null
                                            }}
                                        >  
                                            {
                                                primaryInput == "touch" &&
                                                <motion.div
                                                    style={{
                                                        overflow: "hidden",
                                                        position: "absolute",
                                                        top: "50%",
                                                        left: "50%",
                                                        transform: "translate3d(-50%, -50%, 0)",
                                                        zIndex: 100,
                                                        fontFamily: "var(--font-bold)",
                                                        fontWeight: 600,
                                                        fontStretch: "condensed",
                                                        fontSize: "min(6vw, 33px)" ,
                                                        // mixBlendMode: "difference",
                                                        pointerEvents: "none"
                                                    }}
                                                    exit={{opacity: 0, transition: {
                                                        duration: 0.65
                                                    }}}
                                                    
                                                >
                                                    <AnimatePresence>
                                                    {
                                                        !isVideoPlaying2 && !isVideoLoading2 && !isFullscreen && !isVideoSeeking &&
                                                            <motion.span
                                                            style={{
                                                                display: "inline-block",
                                                            }}
                                                            variants={tsPlayModeVariants}
                                                            initial="initial"
                                                            animate="animate"
                                                            exit="exit"
                                                            >PLAY</motion.span>
                                                    }
                                                    </AnimatePresence>
                                                </motion.div>
                                            }
                                            <AnimatePresence mode="wait">
                                                {isFullscreen &&
                                                    <motion.div className="fullscreen_control_wrapper"
                                                        initial="initial"
                                                        animate="animate"
                                                        exit="exit"
                                                    >
                                                        { !isSecondaryView &&
                                                        <div 
                                                            className="fs_sound"
                                                            
                                                            onClick={handleSoundClick}
                                                        >
                                                            <motion.span
                                                                variants={customTextVariants}
                                                                custom={
                                                                    {
                                                                        'xPos': '0%',
                                                                        'inDur': 1.5,
                                                                        'inDel': 0.5,
                                                                        'inEase': [0.16, 1, 0.3, 1],
                                                                        'outDur': 0.65,
                                                                        'outDel': 0,
                                                                        'outEase': [0.16, 1, 0.3, 1]
                                                                    }
                                                                }
                                                            >
                                                                SOUND
                                                                <div className={`strikethrough ${isMuted ? "strike-active" : ""}`}/>
                                                            </motion.span>
                                                        </div>
                                                        }
                                                        {
                                                            durationTimestamp ?
                                                                <div className="fs_t">
                                                                    <motion.span
                                                                        variants={customTextVariants}
                                                                        custom={
                                                                            {
                                                                                'xPos': '0%',
                                                                                'inDur': 1.5,
                                                                                'inDel': 0.625,
                                                                                'inEase': [0.16, 1, 0.3, 1],
                                                                                'outDur': 0.65,
                                                                                'outDel': 0,
                                                                                'outEase': [0.16, 1, 0.3, 1]
                                                                            }
                                                                        }
                                                                    >{timestamp}&nbsp;</motion.span>
                                                                    <motion.span
                                                                        variants={customTextVariants}
                                                                        custom={
                                                                            {
                                                                                'xPos': '0%',
                                                                                'inDur': 1.5,
                                                                                'inDel': 0.625,
                                                                                'inEase': [0.16, 1, 0.3, 1],
                                                                                'outDur': 0.65,
                                                                                'outDel': 0,
                                                                                'outEase': [0.16, 1, 0.3, 1]
                                                                            }
                                                                        }>/</motion.span>
                                                                    <motion.span
                                                                        variants={customTextVariants}
                                                                        custom={
                                                                            {
                                                                                'xPos': '0%',
                                                                                'inDur': 1.5,
                                                                                'inDel': 0.625,
                                                                                'inEase': [0.16, 1, 0.3, 1],
                                                                                'outDur': 1,
                                                                                'outDel': 0,
                                                                                'outEase': [0.16, 1, 0.3, 1]
                                                                            }
                                                                        }
                                                                    >&nbsp;{durationTimestamp == "0" ? "00:00.000" : durationTimestamp}</motion.span>
                                                                </div>
                                                            : 
                                                                <div className="fs_t">
                                                                    <motion.span
                                                                        variants={customTextVariants}
                                                                        custom={
                                                                            {
                                                                                'xPos': '0%',
                                                                                'inDur': 1.5,
                                                                                'inDel': 0.625,
                                                                                'inEase': [0.16, 1, 0.3, 1],
                                                                                'outDur': 0.65,
                                                                                'outDel': 0,
                                                                                'outEase': [0.16, 1, 0.3, 1]
                                                                            }
                                                                        }
                                                                    >00:00.000</motion.span>
                                                                    <motion.span
                                                                        variants={customTextVariants}
                                                                        custom={
                                                                            {
                                                                                'xPos': '0%',
                                                                                'inDur': 1.5,
                                                                                'inDel': 0.625,
                                                                                'inEase': [0.16, 1, 0.3, 1],
                                                                                'outDur': 0.65,
                                                                                'outDel': 0,
                                                                                'outEase': [0.16, 1, 0.3, 1]
                                                                            }
                                                                        }>/</motion.span>
                                                                    <motion.span
                                                                        variants={customTextVariants}
                                                                        custom={
                                                                            {
                                                                                'xPos': '0%',
                                                                                'inDur': 1.5,
                                                                                'inDel': 0.625,
                                                                                'inEase': [0.16, 1, 0.3, 1],
                                                                                'outDur': 0.65,
                                                                                'outDel': 0,
                                                                                'outEase': [0.16, 1, 0.3, 1]
                                                                            }
                                                                        }
                                                                    >&nbsp;{durationTimestamp == "0" ? "00:00.000" : durationTimestamp}</motion.span>
                                                                </div>
                                                        }
                                                        { !isSecondaryView &&
                                                            <div 
                                                                className="fs_full" 
                                                                onClick={handleFullscreenClick}
                                                            >
                                                                <motion.span
                                                                    variants={customTextVariants}
                                                                    custom={
                                                                        {
                                                                            'xPos': '0%',
                                                                            'inDur': 1.5,
                                                                            'inDel': 0.75,
                                                                            'inEase': [0.16, 1, 0.3, 1],
                                                                            'outDur': 1,
                                                                            'outDel': 0,
                                                                            'outEase': [0.16, 1, 0.3, 1]
                                                                        }
                                                                    }
                                                                >FULLSCREEN</motion.span>
                                                            </div>
                                                        }
                                                        
                                                    </motion.div>
                                                }
                                            </AnimatePresence>
                                            <CornerComponent 
                                                size={40}
                                                wrappingRoom={0}
                                                displayIndex={4}
                                                isFirstLoad={true}
                                                bgCornersActive={false}
                                                performInitial={isFromProject||performInitialGrid||performInitialCorners}
                                                triggerExit={isFullscreen}
                                                isExitingFullscreen={isExitingFullscreen}
                                            />
                                            <ProjectVideo 
                                                videoLink = {data.vimeo}
                                                setVideoProgress={setVideoProgress}
                                                setTimestamp={setTimestamp}
                                                setDurationTimestamp={setDurationTimestamp}
                                                volume={volume}
                                                data={data}
                                                projectNumber={projectNumber}
                                                seekVideoLocation={seekVideoLocation}
                                                handleMainMouseEnter={handleMainMouseEnter}
                                                handleMainMouseLeave={handleMainMouseLeave}
                                                setIsVideoPlaying2={setIsVideoPlaying2}
                                                setIsVideoLoading2={setIsVideoLoading2}
                                                scroller={scroller}
                                                isSecondaryView={isSecondaryView}
                                                isFullscreen={isFullscreen}
                                                dynamicSrcType={dynamicSrcType}
                                                alternateScrollFunc={smoothScrollTo}
                                                alternateScrollRef={touchScrollerRef}
                                                handleSeekEnd={handleSeekEnd}
                                                isVideoSeeking={isVideoSeeking}
                                                handleVideoEnd={handleVideoEnd}
                                            />
                                            {
                                                !isMobile && 
                                                <>
                                                    <motion.div 
                                                        className="muted_wrapper"
                                                        onClick={handleSoundClick}
                                                        initial="initial"
                                                        animate={isFullscreen ? "animate" : "initial"}
                                                        exit="initial"
                                                        variants={fullscreenOptionVariants}
                                                        onMouseEnter={(e) => {
                                                            try{
                                                                let test = document.getElementById('cursor-circle');
                                                                test.classList.add("cursor-active")
                                                            }
                                                            catch{}
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            try{
                                                                let test = document.getElementById('cursor-circle');
                                                                test.classList.remove("cursor-active")
                                                            }
                                                            catch{}
                                                        }}
                                                    >
                                                        <div className="box-hov-indicator box-sm"> 
                                                            <span className="bx-h bx-tl"></span>
                                                            <span className="bx-h bx-tr"></span>
                                                            <span className="bx-h bx-bl"></span>
                                                            <span className="bx-h bx-br"></span>

                                                            <span className="bx-v bx-tl"></span>
                                                            <span className="bx-v bx-tr"></span>
                                                            <span className="bx-v bx-bl"></span>
                                                            <span className="bx-v bx-br"></span>
                                                        </div>
                                                            {
                                                                "SOUND".split("").flat().map((char, idx) => (
                                                                    <motion.span
                                                                        className="aux-char"
                                                                        initial="initial"
                                                                        animate="animate"
                                                                        exit="exit"
                                                                        custom={0.5 + (0.015*(4-idx))}
                                                                        variants={textVariants}
                                                                    >
                                                                        {char}
                                                                    </motion.span>
                                                                ))
                                                            }
                                                        <div className={`strikethrough ${isMuted ? "strike-active" : ""}`}/>
                                                    </motion.div>
                                                    <motion.div
                                                        className="fullscreen_wrapper"
                                                        onClick={handleFullscreenClick}
                                                        initial="initial"
                                                        animate={isFullscreen ? "animate" : "initial"}
                                                        exit="initial"
                                                        variants={fullscreenOptionVariants}
                                                        onMouseEnter={(e) => {
                                                            try{
                                                                let test = document.getElementById('cursor-circle');
                                                                test.classList.add("cursor-active")
                                                            }
                                                            catch{

                                                            }
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            try{
                                                                let test = document.getElementById('cursor-circle');
                                                                test.classList.remove("cursor-active")
                                                            }
                                                            catch{

                                                            }
                                                        }}
                                                    >
                                                        <div className="box-hov-indicator box-sm"> 
                                                            <span className="bx-h bx-tl"></span>
                                                            <span className="bx-h bx-tr"></span>
                                                            <span className="bx-h bx-bl"></span>
                                                            <span className="bx-h bx-br"></span>

                                                            <span className="bx-v bx-tl"></span>
                                                            <span className="bx-v bx-tr"></span>
                                                            <span className="bx-v bx-bl"></span>
                                                            <span className="bx-v bx-br"></span>
                                                        </div>
                                                        {
                                                            "FULLSCREEN".split("").flat().map((char, idx) => (
                                                                <motion.span
                                                                    className="aux-char"
                                                                    initial="initial"
                                                                    animate={"animate"}
                                                                    exit="exit"
                                                                    custom={0.25 + 0.015*idx}
                                                                    variants={textVariants}
                                                                >
                                                                    {char}
                                                                </motion.span>
                                                            ))
                                                        }
                                                    </motion.div>
                                                </>
                                            }
                                        </div>
                                        <motion.div 
                                            className="extra__wrapper"
                                            initial="initial"
                                            animate={isFullscreen ? "exit" : "animate"}
                                            exit="exit"
                                            variants={extraWrapperVariants}
                                            style={{
                                                padding: isMobile ? '0 7px' : '0',
                                                paddingTop: isMobile ? '5px' : '0'
                                            }}
                                            
                                        >
                                            <div className="video_aux__wrapper"
                                            >
                                                <motion.div 
                                                    className="timer__wrapper"
                                                    onClick={handleTimerLineClick}
                                                    initial="initial"
                                                    animate="animate"
                                                    exit="exit"
                                                    variants={timerWrapperVariants}
                                                    ref={timerRef}
                                                >
                                                    {timerLines.map((_, idx) => (
                                                        <motion.div    
                                                            className="timer-line"
                                                            initial="initial"
                                                            animate="animate"
                                                            exit="exit"
                                                            // variants={timerLineVariants}
                                                            custom={idx}
                                                            ref={(el) => (timerLineRefs.current[idx] = el)}
                                                        />
                                                        
                                                    ))}
                                                </motion.div>
                                                <div className="main_meta__wrapper">
                                                    <React.Fragment>
                                                            <div 
                                                                className="meta_first_col"
                                                                style={{
                                                                    fontSize: isMobile && data.title.length + data.artist.length > 30 ? "7vw" : isMobile && data.title.length + data.artist.length > 20 ? "8vw" : ""
                                                                }}
                                                            >
                                                                <motion.div
                                                                    className="proj-title__wrapper"
                                                                    initial="initial"
                                                                    animate="animate"
                                                                    exit="exit"
                                                                    variants={charUpWrapperVariants}    
                                                                    custom={0.25}
                                                                >
                                                                    {
                                                                        !isMobile ? data.title.split("").flat().map((char, idx) => (
                                                                        <motion.span 
                                                                            variants={charUpVariants}
                                                                            style={{
                                                                                display: "inline-block"
                                                                            }}   
                                                                        >
                                                                            {char === " " ? "\u00A0" : char}
                                                                        </motion.span>
                                                                        )) :
                                                                        <motion.span 
                                                                            variants={charUpVariants}
                                                                            style={{
                                                                                display: "inline-block"
                                                                            }}   
                                                                        >
                                                                            {data.title}
                                                                        </motion.span>
                                                                    }
                                                                </motion.div>
                                                            </div>
                                                            {
                                                                !isMobile &&
                                                            <div className="meta_second_col">
                                                                &nbsp;
                                                                {
                                                                    durationTimestamp ?
                                                                        <React.Fragment>
                                                                            <motion.span
                                                                                variants={textVariants}
                                                                                initial="initial"
                                                                                animate="animate"
                                                                                exit="exit"
                                                                                custom={0}
                                                                            >{timestamp}&nbsp;</motion.span>
                                                                            <motion.span
                                                                                variants={textVariants}
                                                                                initial="initial"
                                                                                animate="animate"
                                                                                exit="exit"
                                                                                custom={0.15}>/</motion.span>
                                                                            <motion.span
                                                                                variants={textVariants}
                                                                                initial="initial"
                                                                                animate="animate"
                                                                                exit="exit"
                                                                                custom={0.25}
                                                                            >&nbsp;{durationTimestamp}</motion.span>
                                                                        </React.Fragment>
                                                                    : <React.Fragment />
                                                                }
                                                                &nbsp;
                                                            </div>
                                                            }
                                                            <div 
                                                                className={`meta_third_col ${isMobile ? 'hollow-text' : ''}`}
                                                                style={{
                                                                    fontSize: isMobile && data.title.length + data.artist.length > 30 ? "7vw" : isMobile && data.title.length + data.artist.length > 20 ? "8vw" : ""
                                                                }}    
                                                            >
                                                                <motion.span
                                                                    initial="initial"
                                                                    animate="animate"
                                                                    exit="exit"
                                                                    variants={charUpWrapperVariants}
                                                                    custom={0.125 + (Math.min(data.title.length+2, 12)) * 0.025}
                                                                >
                                                                    {!isMobile ? data.artist.split("").flat().map((char, idx) => (
                                                                        char == " " ? <span>&nbsp;</span> : <motion.span variants={charUpVariants} style={{display: "inline-block"}}>{char}</motion.span>
                                                                    ))
                                                                    :<motion.span variants={charUpVariants} style={{display: "inline-block"}}>{data.artist}</motion.span>
                                                                }
                                                                </motion.span>
                                                            </div>
                                                    </React.Fragment>
                                                </div>
                                                <MetaCreditComponent 
                                                    data={data}
                                                    isSecondaryView={isSecondaryView}
                                                    scroller={scroller}
                                                    isMobile={isMobile}
                                                    creditSectionRef={creditSectionRef}
                                                />
                                            </div>
                                                
                                            <div className="project_gallery__wrapper">
                                                <div className="gallery_content__wrapper">
                                                    {
                                                        renderGallery ?
                                                            isMobile ? 
                                                                <>
                                                                    {
                                                                        data.stills.map((item, idx) => (
                                                                            idx == 1 ? 
                                                                            <>
                                                                                <div className="mob_gallery_img__wrapper">
                                                                                    <ProgressiveGalleryImage
                                                                                        src={item.backgroundImage}
                                                                                        placeholderSrc={item.placeholder}
                                                                                        idx={idx}
                                                                                        scroller={scroller}
                                                                                        startInvisible={idx==0}
                                                                                        scrollInOnLoad={idx == 0}
                                                                                        isMobile={isMobile}
                                                                                        overrideObserver={true}
                                                                                        noEffects={idx !== 0}
                                                                                    />
                                                                                </div>
                                                                                <div className="mobile-ticker__wrapper">
                                                                                    <div className="ticker-wrap tertiary_ticker hollow-text">
                                                                                        <div className="ticker">
                                                                                            <span className="item-collection-1">
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            </span>
                                                                                            <span className="item-collection-2">
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="ticker-wrap first_ticker">
                                                                                        <div className="ticker">
                                                                                            <span className="item-collection-1">
                                                                                            <span className="item">{data.content.rollingTitle[0]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[0]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[0]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[0]}</span>
                                                                                            </span>
                                                                                            <span className="item-collection-2">
                                                                                            <span className="item">{data.content.rollingTitle[0]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[0]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[0]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[0]}</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="ticker-wrap second_ticker">
                                                                                        <div className="ticker">
                                                                                            <span className="item-collection-1">
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            </span>
                                                                                            <span className="item-collection-2">
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            <span className="item">{data.content.rollingTitle[1]}</span>
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            </> :  

                                                                                idx == 3 ? 
                                                                                    <>
                                                                                        <div className="mob_gallery_img__wrapper">
                                                                                            <ProgressiveGalleryImage
                                                                                                src={item.backgroundImage}
                                                                                                placeholderSrc={item.placeholder}
                                                                                                idx={idx}
                                                                                                scroller={scroller}
                                                                                                startInvisible={idx==0}
                                                                                                scrollInOnLoad={idx == 0}
                                                                                                isMobile={isMobile}
                                                                                                overrideObserver={true}
                                                                                                noEffects={idx !== 0}
                                                                                            />
                                                                                        </div>
                                                                                        <MobSplitQuote
                                                                                            splitQuote={data.content.splitQuote} 
                                                                                        />
                                                                                    </>
                                                                                :
                                                                                idx == data.stills.length - 2 ?
                                                                                <>
                                                                                    <div 
                                                                                        className="mob_gallery_img__wrapper"
                                                                                        style={{
                                                                                            position: "relative",
                                                                                            marginTop: data.content.minorQuote[0].length > 1 ? "45vh" : "",
                                                                                            marginBottom:  data.content.minorQuote[0].length > 1 ? "45vh" : ""
                                                                                        }}    
                                                                                    >
                                                                                        <ProgressiveGalleryImage
                                                                                            src={item.backgroundImage}
                                                                                            placeholderSrc={item.placeholder}
                                                                                            idx={idx}
                                                                                            scroller={scroller}
                                                                                            startInvisible={idx==0}
                                                                                            scrollInOnLoad={idx == 0}
                                                                                            isMobile={isMobile}
                                                                                            overrideObserver={true}
                                                                                            noEffects={idx !== 0}
                                                                                        />
                                                                                        <MobOverlapQuote 
                                                                                            quote={data.content.minorQuote}
                                                                                        />
                                                                                    </div>
                                                                                    
                                                                                </>
                                                                                :
                                                                                <div className="mob_gallery_img__wrapper">
                                                                                    <ProgressiveGalleryImage
                                                                                        src={item.backgroundImage}
                                                                                        placeholderSrc={item.placeholder}
                                                                                        idx={idx}
                                                                                        scroller={scroller}
                                                                                        startInvisible={false}
                                                                                        scrollInOnLoad={false}
                                                                                        isMobile={isMobile}
                                                                                        overrideObserver={true}
                                                                                        noEffects={true}
                                                                                    />
                                                                                </div>
                                                                        ))
                                                                    }
                                                                    <MobBoldQuote 
                                                                        content={data.content}
                                                                    />
                                                                </>
                                                            :
                                                                <ProjectGallery 
                                                                    data={data}
                                                                    isSecondaryView={isSecondaryView}
                                                                    scroller={scroller}
                                                                    touchScrollerRef={touchScrollerRef}
                                                                    isMobile={isMobile}
                                                                />
                                                        : <React.Fragment />
                                                    }
                                                </div>
                                            </div>
                                        </motion.div>
                                    </div>
                                    {nextProject && prevProject &&
                                        <motion.div 
                                            className="project_next__wrapper"
                                            style={{
                                                height: isSecondaryView ? `calc((100vw - ${gutter.main*2}px) * ${1/nextProject.aspectRatio}`: null,
                                            }}
                                            initial="initial"
                                            animate="animate"
                                            exit="exit"
                                            variants={nextPrevVariants}
                                        >
                                            <NextPrevComponent 
                                                nextProject={nextProject}
                                                prevProject={prevProject}
                                                scroller={scroller}
                                                handleNavigate={handleNavigate}
                                                isSecondaryView={isSecondaryView}
                                                transitionGLRef={transitionGLRef}
                                                mainBodyRef={mainBodyRef}
                                                extenderRef={extenderRef}
                                                dynamicSrcType={dynamicSrcType}
                                                isSafari={isSafari}
                                            />
                                            {
                                                <motion.div
                                                    className="np_gl__wrapper"
                                                    initial="initial"
                                                    animate="animate"
                                                    exit={isProjectExit ? "exit" : "animate"}
                                                    ref={transitionGLRef}
                                                >
                                                    <motion.div 
                                                        variants={upperGLVariants}
                                                        custom={isProjectExit}
                                                        className="np_gl__upper"
                                                    />
                                                    <motion.div 
                                                        variants={lowerGLVariants}
                                                        custom={isProjectExit}
                                                        className="np_gl__lower"
                                                    />
                                                </motion.div>
                                            }
                                        </motion.div>
                                    }
                                    <div 
                                        className="extender"
                                        ref={extenderRef}
                                    />
                                </React.Fragment>
                            }
                            {
                                data && 
                                <motion.div
                                    initial={{
                                        opacity: performInitialGrid ? 0 : 1
                                    }} animate={{
                                        opacity: isFullscreen ? 0 : 1,
                                        transition: {
                                            delay: isFullscreen ? 0 : 0.35,
                                            duration: 0.5,
                                            ease: isFullscreen ? "easeOut" : "easeIn"
                                        }
                                    }} exit={{
                                        opacity: isProjectExit ? 1 : 0,
                                        transition: {
                                            duration: isProjectExit ? 1 : 0.65
                                        }
                                    }}
                                    style={{
                                        opacity: 1
                                    }}
                                >
                                    <div className="proj-grid-lines p-left-line"/>
                                    <div className="proj-grid-lines p-right-line"/>
                                    <div className="proj-grid-lines p-top-line"/>
                                    <div 
                                        className="proj-grid-lines p-bottom-line"
                                        style={{
                                            top: isSecondaryView ? `calc(60px + (100vw - ${gutter.main*2}px) * ${1/data.aspectRatio}` : `min(calc(100dvh - 180px + 60px), calc(60px + (100vw - ${gutter.main*2}px) * ${9/16}))`
                                        }}
                                    />
                                </motion.div>
                            }
                        </div>
                    </div>
                </div>
                {
                    <>
                        <div className="ll-cover" />
                        <div className="rl-cover" />
                    </>
                }
                {
                    isMobile &&
                    <MobileControls 
                        isMuted={isMuted}
                        handleSoundClick={handleSoundClick}
                        isFullscreen={isFullscreen}
                        handleFullscreenClick={handleFullscreenClick}
                        scrollRef={appliedScrollRef}
                        isVideoPlaying={isVideoPlaying2}
                    />
                }
            </div>
        </>
    )
}

export default Project;